import { render, staticRenderFns } from "./VisitView.vue?vue&type=template&id=2b046afe&"
import script from "./VisitView.vue?vue&type=script&lang=js&"
export * from "./VisitView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VisitView.vue"
export default component.exports